export default __webpack_public_path__ + "static/media/career-workplace.eb636ddd.png";